/**
 * Какие подписи оси X рисовать.
 *
 * ★ Вынесено из `LineChart` отдельной чистой функцией, чтобы правило можно
 * было проверить числами. Внутри компонента его проверял только глаз — и не
 * заметил, что на дневном ряде в сто дней подпись «через одну» даёт полсотни
 * штук на ту же ширину, то есть сплошную нечитаемую полосу.
 */

/** Ширина подписи на глаз плюс зазор: кегль 10,5 px, до ~11 знаков. */
export const MIN_LABEL_GAP = 64;

/** Зазор для подписей-диапазонов («Aug 24–30», «Aug 24–Sep 6»).
 *
 * ★ Отдельная константа, а не то же число: диапазон почти вдвое шире
 * дневной подписи, и с зазором 64 соседние подписи налезали бы друг на
 * друга ровно там, где точек много. */
export const MIN_RANGE_LABEL_GAP = 112;

export function labelPositions(
  count: number,
  xOf: (i: number) => number,
  minGap: number = MIN_LABEL_GAP,
): boolean[] {
  const out = new Array<boolean>(count).fill(false);
  if (count === 0) return out;
  // ★ Начало и конец — ВСЕГДА. По ним читается, за какой период график;
  // именно конца и не хватало, когда последняя точка подписывалась началом
  // своей группы, и график выглядел оборванным раньше срока.
  out[0] = true;
  out[count - 1] = true;
  if (count <= 2) return out;

  let lastX = xOf(0);
  const endX = xOf(count - 1);
  for (let i = 1; i < count - 1; i += 1) {
    const xi = xOf(i);
    // Зазор нужен и до предыдущей подписи, и до конечной: иначе последняя
    // промежуточная налезала бы на неё.
    if (xi - lastX >= minGap && endX - xi >= minGap) {
      out[i] = true;
      lastX = xi;
    }
  }
  return out;
}
